import React from "react";
import { Accent, Container, CtaButton, H2 } from "./ui";
import { checkout } from "../data/content";
export function ClosingSection() {
  return <section className="bg-white py-12 md:py-20" data-id="element-52" data-mp="oux4ov78svzo">
      <Container data-id="element-53" data-mp="12t3stjme3hm5">
        <div className="mx-auto max-w-[720px] text-center" data-id="element-54" data-mp="12tmzg46lajkv">
          <H2 data-id="element-55" data-mp="xu0m7uqrh3c2">
            Less time starting from scratch. <Accent data-id="element-56" data-mp="xs7eec4ewd2h">More time ready for your group.</Accent>
          </H2>
          <p className="mt-4 text-base text-muted sm:text-lg" data-id="element-57" data-mp="1cq87yzhtictg">
            Choose an activity, print the materials and follow the coordinator instructions.
          </p>
          <CtaButton href="#offer-details" className="mt-7 w-full sm:w-auto" data-id="element-58" data-mp="1ljbnddc0wzqq">
            Get the kit — ${checkout.price}
          </CtaButton>
        </div>
      </Container>
    </section>;
}